import { CourseMonitoringDashboard } from "components/monitoring/SectionMonitoringDashboard";

export default function Page() {
  return <CourseMonitoringDashboard />;
}
